import { updateUI } from 'shared/redux/interface'

const store = window.booqableStore

export default {
  addLineQtyUI (line, qty) {
    const newQty = parseInt(line.quantity) + parseInt(qty)
    const action = updateUI(`Line${line.id}`, { quantity: newQty })

    return store.dispatch(action)
  }
}
